module.exports = __webpack_public_path__ + "static/img/eyes_05.f530b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eyes_05.png
// module id = jzr8
// module chunks = 0